import { message } from 'antd';

/**
 * Desempaqueta la respuesta de `eventoService.getListaCorta()` y AVISA si la
 * lista llego cortada.
 *
 * `GET /eventos/lista-corta` corta en 200 filas (`.limit(200)`, evento_routes.py)
 * y manda `total` —el conteo SIN ese tope— justamente para que el front pueda
 * darse cuenta. El backend paga un `count()` por cada request para eso. Hasta
 * que existio este helper, de once consumidores solo `AnimalForm` lo miraba y
 * los otros diez hacian `res.data.eventos || []`: el costo se pagaba en todos y
 * el beneficio lo cobraba uno. Pasado el tope, el remate mas nuevo desaparece
 * del selector con un 200 y una pagina incompleta, y nadie se entera.
 *
 * Vive en UN lugar y no en once para que la proxima pantalla con un selector
 * de remates no nazca ya rota: importa esto y listo.
 *
 * @param {object} res      la respuesta de axios (`{ data: { eventos, total } }`)
 * @param {string} [aviso]  texto del warning; por defecto uno generico. La
 *                          pantalla que sabe que hacer con el remate que falta
 *                          pasa el suyo (AnimalForm manda al productor a
 *                          asignarlo desde la pantalla del remate).
 * @returns {Array} los eventos, siempre un array
 */
export function eventosDeListaCorta(res, aviso) {
  const { eventos = [], total = 0 } = res?.data || {};
  if (total > eventos.length) {
    // La cantidad sale de la respuesta y no de una constante: el tope vive en
    // el backend y un numero copiado aca envejece solo.
    message.warning(
      aviso
      || `Hay más remates de los que entran en la lista: se muestran los ${eventos.length} más recientes.`,
    );
  }
  return eventos;
}
